import React, { useState, useEffect } from 'react';
import {Modal, FormControl, Box, Tooltip, Typography, Snackbar, Alert,TextField,
  Button, Checkbox, FormControlLabel, FormGroup, IconButton,CircularProgress 
} from '@mui/material';
import EditIcon from '@mui/icons-material/EditOutlined';
import { grey, red, blue } from '@mui/material/colors';
import BASE_URL from '../../config'

const style = {
  position: 'absolute', 
  top: '50%', 
  left: '50%', 
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white', 
  borderRadius: 4, 
  p: 4, 
  outline: 'none', 
  width: { xs: '60%', sm: '500px' }, 
  display: 'flex',
  flexDirection: 'column',
  maxHeight: '85%', 
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  // Ocultar para Firefox
  scrollbarWidth: 'none',
  // Ocultar para Internet Explorer y Edge antiguo
  msOverflowStyle: 'none',
};

const Inputstyle = {
  '& .MuiOutlinedInput-root': {
    bgcolor: '#f5f5f5',
    borderRadius: '8px',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover fieldset': { borderColor: grey[400] },
    '&.Mui-focused fieldset': { borderColor: grey[600] },
    '&.Mui-error fieldset': { borderColor: red[700] },
  },
};

export default function Editartareas ({ tareas, refresh }) {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ nombre: '',equipo: []});
  const [confirmType, setConfirmType] = useState(null); 
  const [error, setError] = useState(false);
  const [nombresBD, setNombresBD]=useState([])
  const [loading, setLoading] = useState(false);

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  
  const isTareaValid = form.nombre.trim().length > 3;

  useEffect(() => {
    if (!open) return;
    setForm({
      nombre: tareas.nombre || '',
      equipo: Array.isArray(tareas.equipo) ? tareas.equipo : [],
    });
    const fetchCatalogos = async () => {
      try {
        const res = await fetch(`${BASE_URL}/tareas/getequipos`);
        const dataEquipos = await res.json();
        setNombresBD(Array.isArray(dataEquipos) ? dataEquipos : []);
      } catch (err) {
        console.error("Error cargando catálogos:", err);
      }
    };
    fetchCatalogos();
  }, [open]);

  const handleToggleSelection = (campo, valor) => {
    const listaActual = form[campo];
    const nuevos = listaActual.includes(valor)
      ? listaActual.filter(item => item !== valor)
      : [...listaActual, valor];
    
    setForm({ ...form, [campo]: nuevos });
  };

  const handleClose = () => {
    setConfirmType(null);
    setLoading(false);
    setError('');
    setOpen(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const limits = {
    nombre: 60
    };

    if (limits[name] && value.length > limits[name]) {
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const validateAndOpenSave = () => {

    if (!isTareaValid || form.equipo.length === 0) {
      setError(true);
    } else {
      setError(false);
      setConfirmType('save');
    }
  };

  const handleUpdate = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await fetch(`${BASE_URL}/tareas/${tareas.id}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      });
      const data = await res.json();
      if (res.ok) {
        setSnackbar({ open: true, message: 'Ajustes realizados con éxito', severity: 'success' });
        setTimeout(() => {
          if(refresh) refresh();
          handleClose();
        }, 1500); 
      } else {
        setError(data.message || 'Error al editar las tareas.');
        setConfirmType(null); 
        setLoading(false);
      }
    } catch (e) {
      setError('Error de conexión con el servidor.');
      setConfirmType(null);
      setLoading(false);
    }
  }

  const boxstyle = { 
  mx:0.3, 
  my:0.3,  
  maxHeight: '90px',
  overflowY: 'auto', 
  bgcolor: '#ffffff',

  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-thumb': {
    background: grey[300],
    borderRadius: '8px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: grey[500],
  },
  }

  const ConfirmView = () => (
    <Box sx={style}>
      <Typography variant="h6">
        {confirmType === 'cancel' ? '¿Cancelar edición?' : '¿Guardar cambios?'}
      </Typography>
      <Typography variant="body1" color='textSecondary' sx={{ mt: 1, mb: 3 }}>
        {confirmType === 'cancel' 
          ? '¿Estás seguro que deseas cancelar? Los cambios realizados se perderán.' 
          : '¿Estás seguro que deseas aplicar los cambios a esta tareas?'}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, justifyContent: 'end' }}>
        <Button 
          variant="contained" 
          sx={{ bgcolor: grey[200], color: 'black', textTransform: 'none', px: 3}} 
          onClick={() => setConfirmType(null)}
        >
          {confirmType === 'cancel' ? 'No, continuar' : 'No, revisar'}
        </Button>
        <Button 
          variant="contained" 
          sx={{ bgcolor: 'black', color: 'white', textTransform: 'none', px: 3}}
          onClick={confirmType === 'cancel' ? () => setOpen(false) : handleUpdate}
        >
          {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> :confirmType === 'cancel' ? 'Sí, cancelar' : 'Sí, guardar'}
        </Button>
      </Box>
    </Box>
  );

  return (
    <>
      <IconButton onClick={() => setOpen(true)} 
      sx={{'&:hover': {color:grey[100], bgcolor: blue[400] } }}>
        <EditIcon fontSize="small" />
      </IconButton>

      <Modal open={open} onClose={() => setConfirmType('cancel')}>
        <Box>
          {confirmType ? <ConfirmView /> : (
            <Box sx={style}>
                  {/* TITULOS */}
                <Box sx={{ mb: 2 }}>
                  <Typography variant="h6">Editar Tarea</Typography>
                  <Typography variant="subtitle1" color='textSecondary'>Actualiza la información de la tarea</Typography>
                </Box>

                  {/* FORMULARIO */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>

                  {/* NOMBRE */}
                  <FormControl>
                    <Typography sx={{ mb: 0.5 }}>Nombre de la tarea</Typography>
                      <TextField 
                        size='small'
                        sx={Inputstyle}
                        value={form.nombre}  
                        name={'nombre'}
                        variant="outlined" 
                        error={(form.nombre.length > 0 && !isTareaValid) || (error && form.nombre.length === 0)}
                        helperText={(form.nombre.length > 0 && !isTareaValid) || (error && form.nombre.length === 0) ? "Ingresa un titulo válido para la tarea" : ""}
                        onChange={handleInputChange} 
                      />
                  </FormControl>

                  {/* EQUIPOS */}
                  <FormGroup>
                    <Typography sx={{ mb: 0.5 }}>Equipos</Typography>
                    <Tooltip 
                      title="Debes seleccionar al menos un equipo" 
                      open={error && form.equipo.length === 0} 
                      placement="top-end" 
                      arrow
                      componentsProps={{ tooltip: { sx: { bgcolor: red[700], fontWeight: 'bold' } }, arrow: { sx: { color: red[700] } } }}
                    >
                      <Box sx={{border: `1px solid 
                            ${error && form.equipo.length === 0 ? red[700] : grey[300]}`, 
                            borderRadius: '8px'}}
                      >
                        <Box sx={boxstyle}>
                          {nombresBD.length > 0 ? nombresBD.map((nombre) => (
                            <Box
                              key={nombre}
                              sx={{
                                ':hover': { bgcolor: grey[100] },
                                display: 'flex',
                                alignItems: 'center',
                                height: '30px',
                                transition: 'background-color 0.2s ease',
                              }}>
                              <FormControlLabel
                                control={
                                  <Checkbox 
                                    sx={{
                                      ml: 1, 
                                      color: grey[400], 
                                      '&.Mui-checked': { color: 'black' } 
                                    }} 
                                    size="small" 
                                    checked={form.equipo.includes(nombre)} 
                                    onChange={() => handleToggleSelection('equipo', nombre)}
                                  />
                                }
                                label={
                                  <Typography variant="body2" sx={{ userSelect: 'none', fontWeight: 500 }}>
                                    {nombre}
                                  </Typography>
                                }
                                sx={{ margin: 0, width: '100%' }}
                              />
                            </Box>
                          )) : (
                            <Box sx={{ p: 2, textAlign: 'center' }}>
                              <Typography variant="caption" sx={{ color: grey[500], fontStyle: 'italic' }}>
                                No hay equipos registrados.
                              </Typography>
                            </Box>
                          )}

                        </Box>
                      </Box>
                    </Tooltip>
                  </FormGroup>

                  {/* BOTONES */}
                  <Box sx={{ display: 'flex', gap: 2, justifyContent: 'end', mt: 1 }}>
                    <Button 
                      variant="contained" 
                      sx={{width: { xs: '50%', sm: '20%' } , bgcolor: grey[100], color: 'black', textTransform: 'none', px: 3, '&:hover': { bgcolor: grey[200] } }}
                      onClick={() => setConfirmType('cancel')}
                    >
                      Cancelar
                    </Button>
                    <Button 
                      variant="contained" 
                      sx={{width: { xs: '50%', sm: '40%' } , bgcolor: 'black', color: 'white', textTransform: 'none', px: 3, '&:hover': { bgcolor: 'black' } }}
                      onClick={validateAndOpenSave}
                    >
                      Guardar Cambios
                    </Button>
                  </Box>
                </Box>
              </Box>
            )}
        </Box>
      </Modal>
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={1500} 
        onClose={() => setSnackbar({...snackbar, open: false})} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}